import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";
import MaintenanceDetail from "./MaintenaceDetail";

const styles = {
  wrapper: {
    background: "#f9fafb",
  },

  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
  },

  breadcrumb: {
    fontSize: "14px",
    color: "#6b7280",
  },

  filters: {
    display: "grid",
    gridTemplateColumns: "1.5fr 1fr 1fr 1fr 1fr auto",
    gap: "12px",
    marginBottom: "16px",
    alignItems: "end",
  },

  searchBtn: {
    background: "#14b8a6",
    marginLeft: "660px",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    background: "#fff",
  },

  row: {
    background: "#fff3cd",
    borderBottom: "1px solid #e5e7eb",
  },

  bold: {
    fontWeight: "600",
  },

  muted: {
    fontSize: "12px",
    color: "#6b7280",
  },

  statusBadge: {
    background: "#facc15",
    color: "#000",
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
  },

  viewBtn: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "6px 8px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "6px",
  },

  deleteBtn: {
    background: "#dc2626",
    color: "#fff",
    border: "none",
    padding: "6px 8px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "6px",
  },

  editBtn: {
    background: "#0ea5e9",
    color: "#fff",
    border: "none",
    padding: "6px 8px",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

const MaintenanceSection = () => {
  const [records, setRecords] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [dealerFilter, setDealerFilter] = useState("All");
  const [dealers, setDealers] = useState([]);
  const navigate = useNavigate();

  // useEffect(() => {
  //   api.get("admin/list/").then((res) => setRecords(res.data));
  // }, [navigate]);
  useEffect(() => {
  fetchRecords();
  api.get("companyblog/admin/dealers/").then(res => setDealers(res.data));
}, []);

const fetchRecords = () => {
  api.get("companyblog/admin/list/", {
    params: {
      keyword,
      status: statusFilter,
      dealer: dealerFilter,
    },
  }).then(res => setRecords(res.data));
};

const handleDelete = async (id) => {
  if (!window.confirm("Delete this record?")) return;
  await api.delete(`companyblog/admin/list/delete/${id}/`);
  fetchRecords();
};


  return (
    <>
    <div style={styles.wrapper}>
      {/* Header */}
      <div style={styles.headerRow}>
        <h2>All Maintenance Records</h2>
        <div style={styles.breadcrumb}>
          <span style={{ color: "#2563eb" }}>Home</span> / Maintenance Records
        </div>
      </div>

      {/* Filters */}
      <div style={styles.filters}>
        <div>
          <label>Search by keywords</label>
            <input placeholder="Name/Phone/Tracking..." value={keyword} onChange={(e) => setKeyword(e.target.value)}/>
        </div>

        <div>
          <label>Status</label>
         <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="All">All</option>
          <option value="Pending">Pending</option>
          <option value="Parts Pending">Parts Pending</option>
          <option value="Warranty">Warranty</option>
          <option value="Resolved Problem">Resolved Problem</option>
          <option value="Unable To Repair">Unable To Repair</option>
          <option value="Delivered">Delivered</option>
        </select>
        </div>
       <button style={styles.searchBtn} onClick={fetchRecords}>Search</button>
      </div>

      {/* Table */}
      <table style={styles.table}>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Customer Name</th>
            <th>Contact Address</th>
            <th>Equipment Name</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {records.map((r, i) => (
            <tr key={r.id} style={styles.row}>
              <td>{i + 1}.</td>

              <td>
                <div style={styles.bold}>{r.customer_name}</div>
                <div style={styles.muted}>
                  📅 {new Date(r.created_at).toLocaleString()}
                </div>
              </td>

              <td>
                <div>🏠 {r.customer_address}</div>
                <div>📞 {r.customer_contact}</div>
              </td>

              <td>
                <div>ℹ {r.equipment_name}</div>
                <div style={styles.muted}>#{r.id}</div>
              </td>

              <td>
                <span style={styles.statusBadge}>{r.status}</span>
                <div style={styles.muted}>
                  📅 {new Date(r.created_at).toLocaleString()}
                </div>
              </td>

              <td>
                <button style={styles.viewBtn} onClick={() => setSelectedId(r.id)}
                >
                  👁
                </button>

                <button style={styles.deleteBtn} onClick={() => handleDelete(r.id)}> 🗑 </button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {selectedId && (
        <MaintenanceDetail
          maintenanceId={selectedId}
          onClose={() => {setSelectedId(null)
          fetchRecords();
          }}
        />
      )}
      </>
     );
};

export default MaintenanceSection;
